import { Component, Directive, Input, TemplateRef, ViewContainerRef, Injector } from '@angular/core';
import { CoreLibService } from './core-lib.service';


@Directive({
    selector: '[doclink]',
    standalone: false
})
export class DocLinkDirective {
  private link: string;
  constructor(private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef, private injector: Injector, private coreService: CoreLibService) { }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.templateRef)
    if (this.link && this.coreService.hasAnyClaims(['onlinehelp_show'])) {
      const ref = this.viewContainerRef.createComponent(DocLinkComponent)
      ref.instance.doclink = this.link;
    }
  }

  @Input()
  set doclink(link: string) {
    this.link = link;
  }
}

@Component({
    template: `<p-button class="infoButton" icon="pi pi-info-circle"   [rounded]="true"  [text]="true"  (onClick)="docLinkClicked()"></p-button>`,
    standalone: false
})
export class DocLinkComponent {
  private link: string;
  @Input()
  set doclink(link: string) {
    this.link = link;
  }

  docLinkClicked(): void {
    const event = new CustomEvent('doclink-clicked', { detail: `https://docs.appack.de/${this.link}` });
    window.dispatchEvent(event);
    if (window.parent){
      const payload = {
        type: 'doclink-clicked',
        detail: event.detail
      }
      window.parent.postMessage(payload,'*');
    }
  }
}